var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmsbookingInAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.6663V10.9997C21 10.5576 20.8244 10.1337 20.5118 9.82116C20.1993 9.5086 19.7754 9.33301 19.3333 9.33301H17.1111V9.88856C17.1111 10.1832 16.994 10.4659 16.7857 10.6742C16.5773 10.8826 16.2947 10.9997 16 10.9997C15.7053 10.9997 15.4227 10.8826 15.2143 10.6742C15.006 10.4659 14.8889 10.1832 14.8889 9.88856V9.33301H12.6667C12.2246 9.33301 11.8007 9.5086 11.4882 9.82116C11.1756 10.1337 11 10.5576 11 10.9997V17.6663H13.2222V18.7775H11V21.333C11 22.0694 11.597 22.6663 12.3333 22.6663H14.8889V22.1108C14.8889 21.8161 15.006 21.5335 15.2143 21.3251C15.4227 21.1167 15.7053 20.9997 16 20.9997C16.2947 20.9997 16.5773 21.1167 16.7857 21.3251C16.994 21.5335 17.1111 21.8161 17.1111 22.1108V22.6663H19.6667C20.403 22.6663 21 22.0694 21 21.333V18.7775H18.7778V17.6663H21ZM17.1111 18.7775H14.8889V17.6663H17.1111V18.7775Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmsbookingInAct);
export default __webpack_public_path__ + "static/media/tmsbookingInAct.5d776cfc670d91a98df79239bf289b52.svg";
export { ForwardRef as ReactComponent };